module.exports = __webpack_public_path__ + "static/media/NINE.ec1cd95f.png";